export const isProd = () => {
  return process.env.REACT_APP_ENVIRONMENT === 'production'
}
